import Vue from 'vue';
import VueRouter from 'vue-router';

import store from './store';

// VueRouterプラグインを使用する
// これによって<RouterView />コンポーネントなどを使うことができる
Vue.use(VueRouter);

// ページコンポーネントをインポートする
import MemberCreateComponent from "./components/MemberCreateComponent.vue";
import LoginComponent from "./components/LoginComponent";
import IndexComponent from "./components/IndexComponent.vue";
import MemberShowComponent from "./components/MemberShowComponent.vue";
import MemberEditComponent from "./components/MemberEditComponent.vue";
import Reserve1Component from "./components/Reserve1Component.vue";
import Reserve2Component from "./components/Reserve2Component.vue";
import StatusCode404Component from './components/StatusCode404Component.vue';
import StatusCode500Component from './components/StatusCode500Component.vue';
import PastReservationsComponent from "./components/PastReservationsComponent.vue";

// パスとコンポーネントのマッピング
const routes = [
    {
        path: '/member/create',
        component: MemberCreateComponent,
        meta: {
            isPublic: true,
            breadcrumbs: [
                {name: 'ホーム', path: '/member'},
                {name: '体験予約'},
            ]
        },
        // ログイン中のログインフォームへのアクセスを防ぐナビゲーションガード
        beforeEnter(to, from, next) {
            if (store.getters['auth/check']) {
                next('/member');
            } else {
                next();
            }
        }
    },
    {
        path: '/member/login',
        component: LoginComponent,
        meta: {
            isPublic: true,
            breadcrumbs: [
                {name: 'ホーム', path: '/member'},
                {name: 'ログイン'}
            ]
        },
        // ログイン中のログインフォームへのアクセスを防ぐナビゲーションガード
        beforeEnter(to, from, next) {
            if (store.getters['auth/check']) {
                next('/member');
            } else {
                next();
            }
        }
    },
    {
        path: '/member',
        component: IndexComponent,
    },
    {
        path: '/member/profile',
        component: MemberShowComponent,
        meta: {
            breadcrumbs: [
                {name: 'ホーム', path: '/member'},
                {name: '登録情報'},
            ]
        }
    },
    {
        path: '/member/profile/edit',
        component: MemberEditComponent,
        meta: {
            breadcrumbs: [
                {name: 'ホーム', path: '/member'},
                {name: '登録情報', path: '/member/profile'},
                {name: '編集'},
            ]
        }
    },
    {
        path: '/member/reserve/:roomId([13])/:date',
        component: Reserve1Component,
        meta: {
            breadcrumbs: [
                {name: 'ホーム', path: '/member'},
                {name: 'プログラム予約'},
            ]
        }
    },
    {
        path: '/member/reserve/:roomId([2])/:date',
        component: Reserve2Component,
        meta: {
            breadcrumbs: [
                {name: 'ホーム', path: '/member'},
                {name: 'プログラム予約'},
            ]
        }
    },
    {
        path: '/member/past-reservations',
        component: PastReservationsComponent,
        meta: {
            breadcrumbs: [
                {name: 'ホーム', path: '/member'},
                {name: '過去の予約'},
            ]
        }
    },
    {
        path: '/member/500',
        component: StatusCode500Component,
        meta: {
            isPublic: true,
        },
    },
    {
        path: '*',
        component: StatusCode404Component,
        meta: {
            isPublic: true,
        },
    }
];

// すべてのルートに pathToRegexpOptions を設定して末尾スラッシュのアクセスを禁止する
routes.map(route => {
    route.pathToRegexpOptions = {strict: true}
});

// VueRouterインスタンスを作成する
const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    },
    // HTMLに記述されたベースパスを設定
    base: document.head.querySelector('meta[name="api-base-path"]').content,
    routes: routes
});

// app.jsでインポートするためVueRouterインスタンスをエクスポート
export default router;
